import React from 'react'
import AddTaskIcon from '@mui/icons-material/AddTask';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import warehouseIco from '../../../assets/img/ico/warehouse.svg'
import productionIco from '../../../assets/img/ico/production.svg'
import supplyIco from '../../../assets/img/ico/supply.svg'
import taskListIco from '../../../assets/img/ico/task-list.svg'
import deliveryIco from '../../../assets/img/ico/delivery.svg'
import SidebarItem from './SidebarItem';
import { getCategoryAccessCategory, getFirstAccessPathInCategory } from '../../../helpers/user/UserHelper';
import { useSelector } from 'react-redux';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';

const SidebarMenu = () => {

    const user = useSelector(state => state.user.user)

    // const [loading, setLoad]

    const menuList = [
        // {
        //     category: '/tasks',
        //     url: '/',
        //     title: 'Задачі',
        //     imgSrc: taskListIco
        // },
        {
            category: '/production',
            // url: '/packs', // Тут підставляється автоматично з дозволів
            title: 'Виробництво',
            // imgSrc: productionIco
            imgSrc: <PrecisionManufacturingIcon />,
            isIco: true
        },
        {
            category: '/warehouse',
            // url: '',
            title: 'Склад',
            // imgSrc: warehouseIco
            imgSrc: <WarehouseIcon />,
            isIco: true
        },
        {
            category: '/supply',
            // url: '',
            title: 'Постачання',
            // imgSrc: supplyIco
            imgSrc: <ShoppingCartIcon />,
            isIco: true
        },
        {
            category: '/write-off',
            // url: '',
            title: 'Списання',
            // imgSrc: supplyIco
            imgSrc: <RemoveShoppingCartIcon />,
            isIco: true
        },
        // {
        //     category: '/#test',
        //     url: '',
        //     title: 'Доставка',
        //     imgSrc: deliveryIco
        // },
    ]

    const isActive = (category) => {
        let active = false

        if (window) {
            if (window.location.pathname.includes(category)) {
                active = true
            }
        }

        return active
    }

    const isAccess = (category) => {
        let access = false

        // console.log('category', category)

        // if (window) {
            // if (window.location.pathname.includes(category)) {
                access = getCategoryAccessCategory ({ 
                    // path: window.location.pathname, 
                    permissions: user && user.permissions ? user.permissions : null,
                    categoryName: category
                })
            // }
        // }

        return access
    }

  return (
    <div className='sidebarMenu__main'>
        <ul>
            {
                menuList && menuList.length > 0 ?
                    menuList.map(item => {
                        const firstPath = getFirstAccessPathInCategory({
                            permissions: user && user.permissions ? user.permissions : null,
                            categoryName: item.category
                        })
                        if (isAccess(item.category)) {
                            return <SidebarItem 
                                // key={item.category + item.url}
                                // url={item.category + item.url}
                                key={item.category + firstPath}
                                url={item.category + firstPath}
                                title={item.title}
                                imgSrc={item.imgSrc}
                                isIco={item.isIco}
                                active={isActive(item.category)}
                            />
                        }
                    })
                : ''
            }
        </ul>
    </div>
  )
}

export default SidebarMenu